<template>
    <el-dialog class="dialog" :visible="dialogs.filterOrk" customClass="dialog_main" :append-to-body="true" :close-on-click-modal="false" @close="closeDialog()" @open="handleOpen">
        <div class="dialog__head dialog__head_second" v-if="curKind || curAreas || curQual">
          <div class="dialog__head-inner" v-if="curAreas">
            Выбрана ОПД: {{ curAreas.name }}
          </div>
          <div class="dialog__head-inner" v-if="curKind">
            Выбран ВПД: {{ curKind.name }}
          </div>
          <div class="dialog__head-inner" v-if="curQual">
            Выбрана ПК: {{ curQual.name }}
          </div>
        </div>

        <div slot="title" class="dialog__head dialog__head_second">
            <div class="dialog__head-inner">
                <h3 class="dialog__title">Фильтр по {{ title }}</h3>
            </div>
        </div>

        <div class="dialog__inner">
            <div class="dialog__content">
                <form class="search-form">
                    <div class="search-form__inner">
                        <input type="search" class="input search-form__input" :class="{ 'search-form__input_reset': searchValue && searchValue.length !== 0 }" placeholder="Поиск" v-model.trim="searchValue" @keydown.enter.prevent.stop="filterSearchFunction">

                        <button v-if="searchValue && searchValue.length !== 0" class="search-form__reset" @click="searchValue = ''">
                            <icon-base viewBox="0 0 14 14"><icon-cancel /></icon-base>
                        </button>

                        <button class="search-form__submit" disabled>
                            <icon-base viewBox="0 0 24 24"><icon-search /></icon-base>
                        </button>
                    </div>
                </form>

                <local-preloader v-if="preloader" />

                <template v-else>
                    <el-table
                        cell-class-name="table__cell"
                        class="table table_second"
                        header-cell-class-name="table__title"
                        max-height="300"
                        ref="table"
                        :row-key="filterValue"
                        :data="paginatedData"
                        :default-sort="{ prop: 'code', order: 'ascending' }"
                    >
                        <el-table-column
                                width="24"
                        >
                            <template slot-scope="scope">
                                <div class="table_flex">
                                    <el-checkbox @change="handleSelectionChange([scope.row])"/>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                            label="Название"
                            prop="name"
                            sortable
                            :min-width="90"
                            :sort-orders="['ascending', 'descending']"
                        >
                        </el-table-column>
                    </el-table>

                    <h3 class="dialog__title mt-32 mb-16">Выбранные сущности</h3>

                    <el-table
                        cell-class-name="table__cell"
                        class="table table_second"
                        header-cell-class-name="table__title"
                        max-height="300"
                        :row-key="filterValue"
                        :show-header="false"
                        :data="selection"
                        :default-sort="{ prop: 'code', order: 'ascending' }"
                    >
                        <el-table-column
                            width="24"
                        >
                            <template slot-scope="scope">
                                <div class="table_flex">
                                    <el-checkbox checked @change="deleteSelectionChange([scope.row])"/>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                            label="Название"
                            prop="name"
                            sortable
                            :min-width="90"
                            :sort-orders="['ascending', 'descending']"
                        >
                        </el-table-column>
                    </el-table>

                    <el-pagination
                        background
                        class="mt-24"
                        layout="prev, pager, next"
                        :current-page="page"
                        :hide-on-single-page="true"
                        :page-size="pageSize"
                        :total="total"
                        @current-change="setPage"
                    >
                    </el-pagination>
                </template>
            </div>

            <footer slot="footer" class="dialog__footer mt-24">
                <div class="dialog__footer-inner">
                    <div class="dialog__footer-item">
                        <button type="button" class="btn" @click="closeDialog">Отменить</button>
                    </div>
                    <div class="dialog__footer-item">
                        <button type="submit" class="btn btn_action" @click="submitSelected">Добавить фильтр</button>
                    </div>
                </div>
            </footer>
        </div>
    </el-dialog>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';

import dialog from '@/mixins/dialog';
import LocalPreloader from '../LocalPreloader.vue';

export default {
    components: { LocalPreloader },
    mixins: [ dialog ],
    props: {
        filterBy: {
            type: String,
            default: ''
        },
        filterValue: {
            type: String,
            default: ''
        },
        activeFilters: {
            type: Array,
            default: function() {
                return []
            }
        },
        preloader: {
            type: Boolean,
            default: false
        },

        qualWorkFunctions: {
          type: Array,
          default: function() {
            return []
          }
        },

        curAreas: {
          type: String,
          default: ''
        },
        curKind: {
          type: String,
          default: ''
        },
        curQual: {
          type: String,
          default: ''
        },
        demanded: {
          type: Boolean,
          default: false
        },
    },
    methods: {
        ...mapActions('career', [
          'SILENT_LOAD_WORK_FUNCTIONS_WITH_AREA_KIND_QUAL',
        ]),

        closeDialog() {
            this.selection = []
            
            this.elDialogs.filterOrk = false;
        },
        handleOpen() {
            this.selection = this.activeFilters
        },
        handleSelectionChange(val) {
            this.selection = [...val, ...this.selection];
        },
        deleteSelectionChange(val) {
            this.selection = this.selection.filter(select => !val.find(item => item[this.filterValue] === select[this.filterValue]))
        },
        async submitSelected() {
            const params = {
                selections: this.selection,
                nameFilter: this.filterBy
            }

            this.$emit('addFilters', params)

            this.closeDialog();
        },

        async filterSearchFunction(val) {
          switch (this.filterBy) {
            case 'qualWorkFunctions':
              this.preloader = true
              await this.SILENT_LOAD_WORK_FUNCTIONS_WITH_AREA_KIND_QUAL({
                str: val.target.value,
                area_id: this.curAreas ? this.curAreas.id : null,
                kind_id: this.curKind ? this.curKind.id : null,
                qual_id: this.curQual ? this.curQual.id : null,
                demanded: this.demanded
              })
              this[this.filterBy] = this.work_functions;
              this.preloader = false

              break;
          }
        },
    },
    computed: {
        ...mapState('career', ['work_functions']),

        filtered() {
            let dataName = this.filterBy
            let tempArr = []

            tempArr = this[dataName]
                ? this[dataName].filter(el => !this.selection.find(select => select[this.filterValue] === el[this.filterValue]))
                : []

            return !this.searchValue ? tempArr : tempArr.filter((item) => item.name.toLowerCase().includes(this.searchValue.toLowerCase()));
        },
        paginatedData() {
            // Пагинация
            return this.filtered.slice(this.pageSize * this.page - this.pageSize, this.pageSize * this.page);
        },

        title() {
            switch (this.filterBy) {
                case 'qualWorkFunctions':
                    return 'трудовым функциям'
            
                default:
                    return ''
            }
        }
    }
}
</script>
